
/*============================================================================
  The New Standard Shopify Theme
==============================================================================*/
window.standard = window.standard || {};

standard.cacheSelectors = function () {
  standard.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Header
    $cartPrice: $('#cart-price'),

    // Home Page
    $slider: $('.flexslider'),

    // Navigation
    $navWrap: $('#navWrap'),
    $nav: $('#nav'),

    // Equal height elements
    // $browseByHeight: $('#browse-by-category').find('.coll-image-wrap'),
    // $featuredProductsHeight: $('#featured-products').find('.coll-image-wrap'),
    // $generalProductHeight: $('.product-list').find('.coll-image-wrap'),

    // Placeholders
    $placeholders: $('[placeholder]'),

    // Currency picker
    $currencyToggle: $('#currency-picker-toggle'),
    $currencyPicker: $('#currencies'),

    // Main product image on product page
    $productImage: $('#productPhotoImg')
  }
}

standard.init = function () {
  standard.cacheSelectors();

  standard.cache.$html.removeClass('no-js');
  if ('ontouchstart' in window) {
    standard.cache.$html.removeClass('no-touch').addClass('touch');
  }

  // Run on load
  //standard.responsiveNav();
  //standard.sliders();
  //standard.cartPrice();
  //standard.equalImageHeights();
  //standard.formValidation();
  //standard.currencySelector();
  //standard.saveCartOnClose();
  //standard.lightbox();

  // let's get fancy!
  standard.scrollMagic();
  standard.collectionMagic();
  standard.lazyLoad();
  standard.homePage();
  // standard.collectionPage();
  standard.productImageSwitch();
  standard.productImageZoom();
  standard.relatedProduct();
  standard.placeholderFix();
  standard.discover();
  standard.returnToTop();
  // standard.setupPress();
  standard.setupFixedNav();
  standard.setupSidePanel();
  // standard.setupNewsletter();
  standard.bindClickActions();
  standard.giftReggieCustomInit();
  standard.swatchVariantSetter();
  standard.swatchHover();
  // standard.blogProductClicks();
  standard.abandonedCart();
  // standard.hideFooterSignUp();
  //standard.priceChange();
  // standard.gaTagsSend();

  // rich cart, gift messages, closing
  standard.cartBindings();

  // TODO: why???
  standard.setupNavToggle();

  standard.toggleNavSleepMaterial();
  standard.showNavSleepCard();
  // standard.napkinTable();
}

var popupTimeout = null;

standard.priceChange = function () {
  $(document).ready(function () {

    $('.template-collection .product-details').each(function (i) {
      var that = $(this),
        firstDivChild = that.children("div:first"),
        setInfo,
        price;

      if (!firstDivChild.hasClass('price')) {
        price = firstDivChild.siblings('.price').html().trim();
        setInfo = firstDivChild.html();
        if (setInfo.indexOf('(') > 0) {
          var index = setInfo.indexOf("(");  // Gets the first index where a space occours
          var quantityText = setInfo.substr(index);  // Gets the text part
          setInfo = setInfo.substr(0, index); // Gets the first part
        }
        firstDivChild.siblings('.price').html('');
        firstDivChild.html(setInfo + ' - ' + price);
        firstDivChild.addClass('price');
        if (quantityText) {
          firstDivChild.siblings('.price').html(quantityText);
          firstDivChild.siblings('.price').css('fontSize', '12px');
          firstDivChild.siblings('.price').removeClass('price');
        }
        else {
          firstDivChild.siblings('.price').html('');
          firstDivChild.siblings('.price').removeClass('price');
        }
      }
    });
  });
}

standard.abandonedCart = function () {
  var itemsInCart = parseInt($('#cart-toggle span').html());
  var reason = 'abandoned_cart';

  window.addEventListener("beforeunload", function (e) {
    if (itemsInCart > 0) {
      // hj('tagRecording', [reason]);
      // ga('send', 'event', 'cart', reason, 'abandoned', { 'nonInteraction': 1 });
    }
  });

  var prevKey = "";
  $(document).keydown(function (e) {
    if (e.keyCode == 82 && prevKey) {
      reason = reason + "_page_refresh";
    }
    prevKey = e.metaKey;
  });

}

// standard.blogProductClicks = function () {
//   if (window.location.href.indexOf('blogs')) {
//
//     $('.subhead a').click(function (e) {
//       var that = $(this);
//       var link = that.attr('href');
//       e.preventDefault();
//       ga('send', 'event', 'blog', 'featured article click', link, {
//         'hitCallback':
//           function () {
//             location.href = link;
//           }
//       });
//
//     });
//
//     $('.insta a').click(function (e) {
//       var that = $(this);
//       var link = that.attr('href');
//       ga('send', 'event', 'blog', 'instagram', link, {
//         'hitCallback':
//           function () {
//           }
//       });
//
//     });
//
//     $('.tag a').click(function (e) {
//       var currentPage = document.location.href;
//       var that = $(this);
//       var link = that.attr('href');
//       var description = 'From: ' + currentPage + ' To: ' + link;
//       e.preventDefault();
//       ga('send', 'event', 'blog', 'article tag clicked', description, {
//         'hitCallback':
//           function () {
//             location.href = link;
//           }
//       });
//
//     });
//
//     $('.blog-nav a').click(function (e) {
//       var that = $(this);
//       var link = that.attr('href');
//       e.preventDefault();
//       ga('send', 'event', 'blog', 'landing tag clicked', link, {
//         'hitCallback':
//           function () {
//             location.href = link;
//           }
//       });
//
//     });
//
//     $('.article a').click(function (e) {
//       var that = $(this);
//       var link = that.attr('href');
//       e.preventDefault();
//       ga('send', 'event', 'blog', 'article click', link, {
//         'hitCallback':
//           function () {
//             location.href = link;
//           }
//       });
//
//     });
//
//     $('.product a').click(function (e) {
//       var that = $(this);
//       if (!that.hasClass('swatch')) {
//         var link = that.attr('href');
//         e.preventDefault();
//         ga('send', 'event', 'blog', 'product click', link, {
//           'hitCallback':
//             function () {
//               location.href = link;
//             }
//         });
//       }
//
//
//     });
//   }
//
// }
// standard.napkinTable = function(){
//   //temporarily trigger red variant (for napkin, linens, etc) on collections page
//   $("div.product-details > div.swatches.lowered-swatches > a.swatch.red").trigger('click');
// }


standard.swatchVariantSetter = function () {

  const setPrice = (selectedSwatch) => {
    const $collection__product_card = $(selectedSwatch).closest(".collection__product_card")
    const productHandle =  $collection__product_card.find('.js-product-card a:first').attr('href').split("/products/")[1].split("?")[0] 
    const priceInformation = $(selectedSwatch).closest('.product-details').find('.js-price-update .price-info')
    let productJSON;
    
    if(productJSON){
      let variant = productJSON.product.variants.find(variant=>variant.id === $(selectedSwatch).data("variant-id"))
      productJSON = data;
      if (variant.compare_at_price){
        $(priceInformation).html(`<span class='strikethrough mr05'>$${variant.compare_at_price.split(".00")[0]}</span>$${Math.round(variant.price.split(".00")[0])}`)
      } else {
        $(priceInformation).text(`$${variant.price.split(".00")[0]}`)
      } 
    } else {
      $.getJSON(`https://snowehome.com/products/${productHandle}.json`, (data)=>{
        let variant = data.product.variants.find(variant=>variant.id === $(selectedSwatch).data("variant-id"))
        productJSON = data;
        if (variant.compare_at_price){
          $(priceInformation).html(`<span class='strikethrough mr05'>$${variant.compare_at_price.split(".00")[0]}</span>$${Math.round(variant.price.split(".00")[0])}`)
        } else {
          $(priceInformation).text(`$${variant.price.split(".00")[0]}`)
        } 
      })
    } 
  }

  // <----- SWATCH ON LOAD FUNCTION -----> //
  $('.swatches a.swatch').each((i, swatch) => {
    //SETS HIGHTLIGHT CLASS AND CIRCLE AROUND INITIAL SELECTED SWATCH VARIANT
    $(swatch).data('image') === $(swatch).closest('.product-details').siblings('a').find('img.orig').data('image-src')
    ? $(swatch).addClass('highlight')
    : $(swatch).removeClass('highlight')

    //SETS PRODUCT CARD <a> HREF LOCATION FROM DEFAULT PRODUCT VARIANT TO THE SELECTED VARIANT ON LOAD
    $(swatch).hasClass('highlight') &&
    $(swatch).closest('.collection__product_card').find('.product-link').attr('href', $(swatch).data('variant-url'))

    //SETS PRODUCT CARD PRICE TO THE SELECTED VARIANT ON LOAD
    $(swatch).hasClass('highlight') &&
    !$(swatch).closest(".collection__product_card").hasClass('registry-product') && setPrice($(swatch))
  })

  // <----- SWATCH ONCLICK FUNCTION -----> //
  $('.swatches a.swatch').click(function () {
    const clickedSwatch = $(this);
    if (!clickedSwatch.hasClass('highlight')) {
      //CLEARS HIGHLIGHTED SWATCHES
      clickedSwatch.siblings('a.swatch').each( (_, swatch) => $(swatch).removeClass('highlight')); 

      // SETS NEW HIGHLIGHTED SWATCH
      clickedSwatch.addClass('highlight'); 

      //SETS NEW PRODUCT CARD IMAGE
      let pictureHolder = clickedSwatch.closest('form.js-product-card').find('a:first');
      let newPictureSrc = clickedSwatch.data('image');
      pictureHolder.find('img.orig').attr('src', newPictureSrc)
    }

    //SETS PRODUCT CARD PRICE TO THE SELECTED VARIANT ON SWATCH CLICK
    !$(clickedSwatch).closest(".collection__product_card").hasClass('registry-product') && setPrice(clickedSwatch)

    //SETS PRODUCT CARD <a> HREF LOCATION FROM DEFAULT PRODUCT VARIANT TO THE SELECTED VARIANT ON SWATCH CLICK
    $(clickedSwatch).closest('.collection__product_card').find('.product-link').attr('href', $(clickedSwatch).data('variant-url'))
  }); 
}

standard.swatchHover = function () {
  $('.swatches a.swatch').mouseenter(function () {
    var hoveredSwatch = $(this);
    var swatches = hoveredSwatch.siblings('a.swatch');
    var pictureHolder = hoveredSwatch.closest('.product-details').siblings('a');
    var originalPictureSrc = pictureHolder.children('img.orig').attr('src');
    if (!hoveredSwatch.hasClass('highlight')) {
      var newPictureSrc = hoveredSwatch.data('image');
      pictureHolder.children('img.orig').stop().animate({ opacity: 0 }, 0, function () {
        $(this).attr('src', newPictureSrc);
        $(this).animate({ opacity: 1 }, 400);
      });
    }

    hoveredSwatch.mouseleave(function () {
      if (!hoveredSwatch.hasClass('highlight')) {
        pictureHolder.children('img.orig').stop().animate({ opacity: 0 }, 0, function () {
          $(this).attr('src', originalPictureSrc);
          $(this).animate({ opacity: 1 }, 200);
        });
      }
    });
  });
}

standard.giftReggieCustomInit = function () {

  (function ($) {
    $(document).ready(function () {
      $('.giftreggie-browse-add-products a, .giftreggie-no-products a').attr('href', '/collections/eat');
    })
  })(jQuery);

  (function ($) {

    $.fn.waitUntilExists = function (handler, shouldRunHandlerOnce, isChild) {
      var found = 'found';
      var $this = $(this.selector);
      var $elements = $this.not(function () { return $(this).data(found); }).each(handler).data(found, true);

      if (!isChild) {
        (window.waitUntilExists_Intervals = window.waitUntilExists_Intervals || {})[this.selector] =
          window.setInterval(function () { $this.waitUntilExists(handler, shouldRunHandlerOnce, true); }, 500)
          ;
      }
      else if (shouldRunHandlerOnce && $elements.length) {
        window.clearInterval(window.waitUntilExists_Intervals[this.selector]);
      }

      return $this;
    }

  }(jQuery));

  var minimize_bound, close_bound, initial_height, selector, initial_width;
  minimize_bound = false;
  close_bound = false;

  $('.giftreggie-popup-minimize').waitUntilExists(function () {
    $('.giftreggie-popup-minimize').html('- hide');
    $('.giftreggie-popup-minimize').addClass('snowe-giftreggie-popup-minimize');
    $('.giftreggie-popup-minimize').unbind();
    $('.giftreggie-popup-minimize').removeClass('giftreggie-popup-minimize');
    $('.giftreggie-popup-close').unbind();
    $('.giftreggie-popup-close').addClass('snowe-giftreggie-popup-close');
    $('.giftreggie-popup-close').removeClass('giftreggie-popup-close');

    if (!minimize_bound) {
      minimize_bound = true;
      $('.snowe-giftreggie-popup-minimize').click(function () {

        selector = $(this).parent().children(".giftreggie-popup-body");

        if (selector.hasClass('gr-hide')) {
          $('.snowe-giftreggie-popup-minimize').html('- hide');
          selector.slideDown();
          selector.removeClass('gr-hide');
        }
        else {
          $('.snowe-giftreggie-popup-minimize').html('+ show');
          selector.slideUp();
          selector.addClass('gr-hide');


        }

      });


    }
  });

  $('.snowe-giftreggie-popup-close').waitUntilExists(function () {

    if (!close_bound) {
      close_bound = true;
      $('.snowe-giftreggie-popup-close').click(function () {
        selector = $(this).parent();
        selector.slideUp();

      });
    }

  });

  $('#giftreggie-product-table').waitUntilExists(function () {
    $('#giftreggie-product-table div div').first().html('Product Name');
  });

  $('#giftreggie-collection-admin').waitUntilExists(function () {
    if (location.href.indexOf("products") == -1) {
      $('#giftreggie-collection-admin p').css('display', 'none');
    }
  });
  $('#giftreggie-collection-info').waitUntilExists(function () {
    if (location.href.indexOf("products") == -1) {
      $('#giftreggie-collection-info p').css('display', 'none');
    }
  });
  $('#giftreggie-product-admin').waitUntilExists(function () {
    $('.giftreggie-registry-notification').html(function (_, ctx) {
      ctx = ctx.replace('.', '');
      return ctx.replace("You are currently administering", "You are managing");
    });
    $('#giftreggie-product-admin-add p').html(function (_, ctx) {
      return ctx.replace("! Fill out this form to add the product to it.", ". Enter the number of items you want and click add to include in your registry.");
    });
    $('#giftreggie-product-admin-change p').first().html(function (_, ctx) {
      return ctx.replace('This product is already on the registry! You can modify its properties below.', 'This product is in the registry. To modify, enter the amount desired and click update.');
    });

    $('#giftreggie-product-admin-change p input').each(function (i) {
      var input = $(this);
      if (i == 0) {
        input.val('Update');
        input.css('marginRight', '10px');
      }
      else if (i == 1) {
        input.val('Remove');
      }
    });
  });
  $('#giftreggie-product-admin-add').waitUntilExists(function () {
    $('#giftreggie-product-admin-add p input').val('Add');
  });
  // $('.giftreggie-popup-stop').waitUntilExists(function(){
  //       $('.giftreggie-popup-stop').val('Exit >');
  // });
  $('#giftreggie-product-info').waitUntilExists(function () {

    $('.giftreggie-registry-notification').html(function (_, ctx) {
      ctx = ctx.replace('.', '');
      return ctx.replace("You are currently shopping for", "You are shopping for");
    });

    $('#giftreggie-product-info').html(function (_, ctx) {
      return ctx.replace("Below is a list of the items selected. To make a purchase, choose items from the product page and add to cart. Any items purchased will be marked off the registry.", "Add products to the cart and any items purchased will be marked off the registry.");
    });

  });

  $('#registry-update-cart').click(function (event) {
    event.stopPropagation();
    window.location.reload();
    return false;
  });

} //end standard.giftreggiecustominit

standard.bindClickActions = function () {
  $('.toggle-expand').click(function () {
    $(this).next().stop().slideToggle('fast');
  });

  // $('a.static.discover').click(function (e) {
  //   // hj('tagRecording', ['homepage_down_arrow_click']);
  //   ga('send', 'event', 'homepage', 'down arrow click', 'discover', { 'nonInteraction': 1 });
  //   window.standard.scrollTo('.row.intro', 0);
  //
  // });

}

// standard.navigateOutOfNewsletter = function () {
//   snwnws = getCookie('snwnws7');
//
//   if (!snwnws || snwnws === "") {
//     // hj('tagRecording', ['newsletter_cta_clicked']);
//     // ga('send', 'event', 'homepage', 'navigate_out', 'lightbox', { 'nonInteraction': 1 });
//     setCookie('snwnws7', 'closed', true);
//   }
// }
//
// standard.setupNewsletter = function () {
//   var location = window.location.pathname,
//     fullUrl = window.location.href;
//   /*OUTBRAIN*/
//   if (fullUrl.indexOf("utm_source=outbrain") >= 0) {
//     var snwnws = getCookie('snwnws7');
//     if (!snwnws || snwnws === "") {
//       var popup = new Popup($('.magazine.popup'));
//
//       popupTimeout = window.setTimeout(function () {
//         popup.show({
//           before: function () {
//             var $popup = this;
//             $popup.find('.tip-close a').click(function () {
//               // Only mark the cookie as closed if it is blank, shouldn't happen
//               popup.hide();
//             });
//             $popup.find('form').submit(function () {
//               popup.hide();
//             });
//           },
//           hide: function () {
//             snwnws = getCookie('snwnws7');
//             if (!snwnws || snwnws === "") {
//               // hj('tagRecording', ['blog_lightbox_closed']);
//               // ga('send', 'event', 'blog', 'close', 'lightbox', { 'nonInteraction': 1 });
//               setCookie('snwnws7', 'closed', true);
//             }
//           }
//         });
//       }, 10000);
//     }
//     return;
//   }
//
//   if ($('body').hasClass('customer-logged-in')) return;
//   if (location.indexOf("/a/i") >= 0) return;
//
//   var snwnws = getCookie('snwnws7');
//   /*
//   if (!snwnws || snwnws === "") {
//     var popup = new Popup($('.newsletter.popup'));
//
//     popupTimeout = window.setTimeout(function() {
//       popup.show({
//         before: function() {
//           var $popup = this;
//             $popup.find('.tip-close a').click(function() {
//               // Only mark the cookie as closed if it is blank, shouldn't happen
//               popup.hide();
//             });
//             $popup.find('form').submit(function() {
//               popup.hide();
//             });
//         },
//         hide: function() {
//           snwnws = getCookie('snwnws7');
//           if (!snwnws || snwnws === "") {
//             //hj('tagRecording', ['newsletter_lightbox_closed']);
//             // ga('send', 'event', 'homepage', 'close', 'lightbox', {'nonInteraction': 1});
//             setCookie('snwnws7', 'closed', true);
//           }
//         }
//       });
//     }, 20000);
//   }*/
// }

standard.referralClicked = function () {
  var d = new Date();
  setCookie('snwnws', d.toGMTString());
  // ga('send', 'event', 'homepage', 'click', 'lightbox', { 'hitCallback': function () { location.href = '/a/i'; } });
}

standard.newsletterSubmitted = function (source) {
  var d = new Date();
  setCookie('snwnws7', d.toGMTString());
  var submitted = 'submitted_' + source;
  var hotjarsubmitted = 'newsletter_' + submitted;
  //hj('tagRecording', [hotjarsubmitted]);
  // ga('send', 'event', 'newsletter', submitted, source, { 'nonInteraction': 1 });

  var popup = new Popup($('.newsletter-thanks.popup'));
  popup.show({
    before: function () {
      var $popup = this;
      $popup.find('.tip-close a').click(function () {
        popup.hide();
      });
    },
  });
}

var currentPressSlide = 0;
var slideInterval = null;

standard.setupPress = function () {
  var $press = $('#press');
  var $slides = $press.find('li');
  if ($press.length == 0) return;

  var max = 0;
  var buffer = 50;
  $slides.each(function () {
    var $slide = $(this);
    var height = $slide.height();
    if (height > max) max = height;
  });
  $press.find('ul').css({ 'height': (max + buffer) });


  if (!$('body').hasClass('mobile')) {
    $press.hover(function () {
      $press.addClass('hover');
    }, function () {
      $press.removeClass('hover');
    });
  }

  $press.find('a.btn-next').on('click touchstart', function (e) {
    e.preventDefault();
    e.stopPropagation();

    currentPressSlide += 1;
    if (currentPressSlide > $slides.length - 1) currentPressSlide = 0;
    standard.gotoPressSlide(currentPressSlide);
  })

  $press.find('a.btn-prev').on('click touchstart', function (e) {
    e.preventDefault();
    e.stopPropagation();

    currentPressSlide -= 1;
    if (currentPressSlide < 0) currentPressSlide = $slides.length - 1;
    standard.gotoPressSlide(currentPressSlide);
  })

  slideInterval = window.setInterval(function () {
    if (!$press.hasClass('hover')) {
      currentPressSlide += 1;
      if (currentPressSlide > $slides.length - 1) currentPressSlide = 0;
      standard.gotoPressSlide(currentPressSlide);
    }
  }, 4000);

}


standard.setCookie = function (name, value) {
  var date = new Date();
  date.setTime(date.getTime() + (4000000));

  var expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + value + expires + "; path=/";
}
standard.getCookie = function (name) { var a = document.cookie.split(';'); for (var i = 0; i < a.length; i++) { var c = a[i].replace(/^\s*/, ''); if (c.indexOf(name) == 0) return c.substring(name.length + 1, c.length); } }

standard.homePage = function () {

  if ($('.template-index')) {
    if (standard.getCookie('homepage') !== 'true') {
      setTimeout(function () {
        $('.first-time').addClass('text-in');
      }, 600);
      setTimeout(function () {
        $('.first-time').addClass('background-in');
      }, 1300);
      setTimeout(function () {
        $('.push-mobile').addClass('push-in');
        $('#promo').addClass('show-promo');
      }, 1500);
      setTimeout(function () {
        $('body').addClass('content-in');
      }, 1500);

      standard.setCookie('homepage', 'true');
    }
    else {
      $('body').removeClass('first-time');
      $('#promo').addClass('show-promo');
    }
  };
};

standard.collectionPage = function () {

  if ($('body').hasClass('template-collection')) {
    setTimeout(function () {
      $('.fade-in').addClass('text');
    }, 700);
    if ($('body#gifts').length < 1) {
      if ($('#magicCollection').length > 0) {
        $(window).scroll(function () {
          var magicCollectionTop = $('#magicCollection').offset().top;
          var y = $(this).scrollTop();

          if (y >= magicCollectionTop - 450) {
            $('#magicCollection').addClass('active');
          }

        });
        if ($('body#bundles').length < 1) {
          if ($('#Sets').length > 0) {

            $(window).scroll(function () {
              var setSection = $('#Sets').offset().top;
              var y = $(this).scrollTop();

              if (y >= setSection - 550) {
                $('#Sets').addClass('active');
              }

            });
          }
        }
      }

    }
    else {
      $(window).scroll(function () {
        var magicCollectionTop = $('#magicCollection').offset().top;
        var y = $(this).scrollTop();

        if (y >= magicCollectionTop - 450) {
          $('#magicCollection').addClass('active');
        }

      });

    }
  }
  else if ($('body').hasClass('template-page')) {
    setTimeout(function () {
      $('.fade-in').addClass('text');
    }, 700);
  }

}

standard.lazyLoad = function () {

  $('.lazy-load-hero').imageloader(
    {
      background: true,
      callback: function (elm) {
        $(elm).addClass('fade-in');
      }
    }
  );

  $('.lazy-load').imageloader(
    {
      callback: function (elm) {
        $(elm).fadeIn(400);
      }
    }
  );
};

standard.scrollMagic = function () {
  if ($('body').hasClass('template-index')) {
    var scrollItems = $('.row.collection[id]'),
      scrollItemsLength = scrollItems.length,
      count = 0;

    scrollItems.each(function () {

      $(this).data("closedOffset", $(this).offset().top);
      count++;

      if (count == scrollItemsLength) {

        bindHomePageScroll(scrollItems);
      }
    });
  };

};
standard.collectionMagic = function () {
  //cycle through collections
  if ($('body').hasClass('template-index')) {
    var cycleCollection = function () {
      var $activeTab = $('ul.nav-tabs li.active');
      var $activeEl = $('.active .in');
      var index = parseInt($activeTab.attr('data-index'));
      var nextIndex;
      if (index < 4) {
        nextIndex = index + 1;
      }
      else {
        nextIndex = 0;
      }
      // Find $nextLink, $nextTab, $cat, and $catEl to add or remove active class as appropriate
      var $nextLink = $("ul.nav-tabs li[data-index='" + nextIndex + "'] a.collections-nav-tab");
      var $nextTab = $("ul.nav-tabs li[data-index='" + nextIndex + "'] a.collections-nav-tab");
      var $cat = $nextTab.attr('href')
      var $catEl = $(`${$cat}`)
      // Add and remove active class as approrpiate to cycle through all 5 categories
      $nextLink.parent().addClass("active");
      $catEl.addClass("active in")
      $activeTab.removeClass("active");
      $activeEl.removeClass("active in")
      // The 8 lines above this essential accomplish the same as the 1 line below; however, this was commented out due to "click" events having unwanted consequences with Search Bar functionality
      // $nextLink.click().delay(200);
    }
    var intervalID = setInterval(cycleCollection, 6000);
    $('ul#collections-nav-tabs li,div.collection-tab-products-row,div.collection-tab-feature-row div.collection-cta').on('mouseover touchstart', function () {
      clearInterval(intervalID);
      intervalID = 0;
      $('ul#collections-nav-tabs li,div.collection-tab-products-row,div.collection-tab-feature-row div.collection-cta').unbind('mouseover');
      $('ul#collections-nav-tabs li,div.collection-tab-products-row,div.collection-tab-feature-row div.collection-cta').unbind('touchstart');
    });
  };
}

bindHomePageScroll = function (scrollItems) {
  var first = scrollItems.get(0);
  var second = scrollItems.get(1);
  var third = scrollItems.get(2);
  var fourth = scrollItems.get(3);

  $(window).scroll(function (event) {
    var y = $(this).scrollTop();


    if (y >= $(first).data("closedOffset") - 500) {

      $(first).addClass('active').delay(500).queue(function () {
        $(this).addClass('active-text');
      });
    }
    if (y >= $(second).data("closedOffset") - 500) {

      $(second).addClass('active').delay(500).queue(function () {
        $(this).addClass('active-text');
      });

    }
    if (y >= $(third).data("closedOffset") - 500) {
      $(third).addClass('active').delay(500).queue(function () {
        $(this).addClass('active-text');
      });

    }
    if (y >= $(fourth).data("closedOffset") - 500) {
      $(fourth).addClass('active').delay(500).queue(function () {
        $(this).addClass('active-text');
      });

    }
  });
};

standard.gotoPressSlide = function (index) {
  var $ul = $('#press ul');
  $ul.find('li.active').removeClass('active');
  $($ul.find('li')[currentPressSlide]).addClass('active');
};


standard.setupNavToggle = function () {
  var $navToggle = $('.nav.mobile .nav-toggle a');
  var $background;
  var $body = $('body');
  var event = "click";

  if ('ontouchstart' in window) {
    event = "touchstart";
  }
  $navToggle.on(event, function (e) {
    standard.navToggle(e);
  });
}

standard.navToggle = function (e) {
  var $navToggle = $('.nav.mobile .nav-toggle a');
  var $background;
  var $body = $('body');
  var $shift = $('#shift');

  if ($body.hasClass('nav-toggle')) {
    standard.hideNavToggle();
    return false;
  }

  $background = $("<div class='popup-background'></div>")
  $background.on('mousedown touchstart', function (e) {
    e.preventDefault();
    e.stopPropagation();
    standard.hideNavToggle();
  });
  $body.append($background);

  // No scroll mobile
  $shift.addClass('no-scroll');

  // $body.bind('touchmove.navToggle', function(e) {
  //  e.preventDefault();
  //  e.stopPropagation();
  //});

  $body.addClass('nav-toggle');
  $background.css({ 'opacity': '0.8' }).show();

  return false;
}

standard.hideNavToggle = function () {
  var $shift = $('#shift');
  $shift.removeClass('no-scroll');
  $('body').removeClass('nav-toggle');
  $('body').unbind('touchmove.navToggle'); // no scroll mobile unbind
  $('.popup-background').remove();
}

var stickyHidingTimeout = null;

standard.setupFixedNav = function () {
  var $sticky = $('nav.sticky');
  var $navbar = $sticky.find('.navbar-container');
  var $scrolly = $('nav.scrolly');
  var $window = $(window);
  var $body = $('body');
  var trigger = 110;

  $window.bind('scroll', function (e) {
    if ($window.scrollTop() > trigger) {
      if (!$body.hasClass('sticky')) {
        if (stickyHidingTimeout) window.clearTimeout(stickyHidingTimeout);
        stickyHidingTimeout = null;
        $navbar.show();
        $body.addClass('sticky');
      }
    } else {
      if ($body.hasClass('sticky')) {
        $body.removeClass('sticky');
        stickyHidingTimeout = window.setTimeout(function () {
          $navbar.hide();
        }, 300);
      }
    }
  });
}

standard.closeSidePanel = function () {
  var $body = $('body');
  var $side = $('#side');
  var $promo = $('#promo');

  $body.removeClass('side-open');
  $promo.removeClass('side-open');
  $body.unbind('mousedown.side');
  $body.unbind('touchstart.side');
  $body.unbind('keyup.side'); // escape unbind
}

standard.showSidePanel = function () {
  if ($('html').hasClass('ie')) {
    return;
  }
  var $side = $('#side');
  var $body = $('body');
  var $promo = $('#promo');

  var snwcrt = getCookie("snwcrt");
  if (!snwcrt || snwcrt === "") {
    var d = new Date();
    setCookie('snwcrt', d.toGMTString());
  }

  $body.addClass('side-open');
  $promo.addClass('side-open');
  $side.find('.tip-close a').click(function () {standard.closeSidePanel()});

  // Escape closes the side panel
  $('body').bind('keyup.side', function (e) {
    if (e.which === 27) {
      e.preventDefault();
      e.stopPropagation();
      standard.closeSidePanel();
    }
  });

  $('body').bind('mousedown.side touchstart.side', function (e) {
    var $target = $(e.target);
    if ($target.parents('#side').length > 0 || $target.attr('id') == 'side') {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    standard.closeSidePanel();
    // hj('tagRecording', ['Cart_closed_body_clicked']);
    // ga('send', 'event', 'Cart', 'close with body click', 'Side Panel', { 'nonInteraction': 1 });
    return false;
  });

}

standard.setupSidePanel = function () {
  if ($('html').hasClass('ie')) {
    return;
  }
  var $side = $('#side');
  var $body = $('body');
  $('a.cart').bind('mousedown touchstart', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($body.hasClass('nav-toggle')) {
      standard.hideNavToggle();
    }
    
    if ($body.hasClass('side-open')) {
      standard.closeSidePanel();
      return false;
    }
    if(window.location.href.split('.com/')[1] != 'cart'){
      standard.showSidePanel();
      // hj('tagRecording', ['Cart_Opened']);
      // ga('send', 'event', 'Cart', 'open', 'Side Panel', { 'nonInteraction': 1 });
      return false;
    }
  })
}

standard.discover = function () {
  $('#discover').bind('mousedown touchdown', function (e) {
    // ga('send', 'event', 'homepage', 'click', 'learn_more', { 'nonInteraction': 1 });
    var top = $('#content').offset().top - 75; // == height of the sticky nav
    $('html, body').animate({ scrollTop: top }, 900, 'easeOutQuint');
    return false;
  });
}

standard.scrollTo = function (id, buffer) {
  var top = $(id).offset().top - (50 + buffer); // == height of the sticky nav
  $('html, body').animate({ scrollTop: top }, 1500, 'easeOutQuint');
  return false;
}

standard.scrollToHelp = function (el, id, buffer) {
  $('.topics li').removeClass('active');
  $(el).addClass('active');

  var top = $(id).offset().top - (75 + buffer); // == height of the sticky nav
  $('html, body').animate({ scrollTop: top }, 1500, 'easeOutQuint');
  return false;
}

standard.returnToTop = function () {
  $('#palm').bind('mousedown touchdown', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('html, body').animate({ scrollTop: 0 }, 1500, 'easeOutQuint');

    return false;
  });
}

standard.accessibleNav = function () {
  var $nav = standard.cache.$nav,
    $allLinks = $nav.find('a'),
    $topLevel = $nav.children('li').find('a'),
    $parents = $nav.find('.has-dropdown'),
    $subMenuLinks = $nav.find('.sub-nav').find('a'),
    activeClass = 'nav-hover',
    focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function (evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  $parents.on('mouseleave', function () {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function (evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function () {
    handleFocus($(this));
  });

  $allLinks.blur(function () {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul');
    hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
      isSubItem = $('.sub-nav').has($el).length,
      $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function () {
      standard.cache.$body.on('touchstart', function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    standard.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
}

standard.responsiveNav = function () {
  $(window).resize(function () {
    waitForFinalEvent(function () {
      // Replace original nav items and remove more link
      standard.cache.$nav.append($('#moreMenu--list').html());
      $('#moreMenu').remove();
      standard.alignMenu();
    }, 200, 'uniqueID');
  });
  standard.alignMenu();
}



standard.alignMenu = function () {
  var $nav = standard.cache.$nav,
    w = 0,
    i = 0,
    wrapperWidth = standard.cache.$navWrap.outerWidth() - 130, // magic number for 'More' link width
    menuhtml = '';

  $.each($nav.children(), function () {
    var $el = $(this);
    w += $el.outerWidth(true);
    if (wrapperWidth < w) {
      menuhtml += $('<div>').append($el.clone()).html();
      $el.remove();
      i++;
    }
  });

  if (wrapperWidth < w) {
    $nav.append(
      '<li id="moreMenu" class="nav-item has-dropdown">'
      + '<a href="#" class="nav-item-link">' + "More" + ' <span class="icon icon-arrow-down" aria-hidden="true"></span></a>'
        + '<ul id="moreMenu--list" class="sub-nav">' + menuhtml + '</ul></li>'
    );
}

// Finish by resetting accessibleNav function
standard.accessibleNav();
}

standard.sliders = function () {
  var $slider = standard.cache.$slider;

  if ($slider.length) {
    $(window).on('load', function () {
      $slider.flexslider({
        animation: 'slide',
        animationSpeed: 500,
        pauseOnHover: true,
        keyboard: false,
        slideshow: true,
      slideshowSpeed: 7000,
  smoothHeight: true,
    end: function(slider) {
      slider.flexAnimate(1);
      slider.flexAnimate(0);
    }
});
    });
  }
};

standard.toggleNavSleepMaterial = function () {
  var $materialsToggler = $('.materials-card-front');
  var $sleepProductsToggler = $('.materials-card-back')

  $materialsToggler.on('click', function (evt) {
    $('.info-card .front').css({ 'transition': '0.5s linear', 'transform': "rotateY(-180deg)" });
    $('.info-card .back').css({ 'transition': '0.5s linear', 'transform': "rotateY(0deg)" });
    document.cookie = "sleepmaterials=materials; expires=0; path=/";
  });
  $sleepProductsToggler.click(function () {
    $('.info-card .back').css({
      'transition': '0.5s linear', 'transform': "rotateY(-180deg)", '-webkit-transform-style': "preserve-3d", 'transform-style':
        "preserve-3d"
    });
    $('.info-card .front').css({ 'transition': '0.5s linear', 'transform': "rotateY(0deg)" });
    // setCookie('sleepmaterials', 'products', '');
    document.cookie = "sleepmaterials=products; expires=0; path=/";
  });
};

standard.showNavSleepCard = function () {
  sleepmaterials = getCookie('sleepmaterials');
  if (sleepmaterials === "materials") {
    $('.info-card .front').css({ 'transition': '0.5s linear', 'transform': "rotateY(-180deg)" });
    $('.info-card .back').css({ 'transition': '0.5s linear', 'transform': "rotateY(0deg)" });
  }
}


standard.cartPrice = function () {
  var $price = standard.cache.$cartPrice,
    priceCount = $price.text().length;

  if (priceCount <= 5) { $price.css('opacity', 1); }
  if (priceCount >= 6) { $price.css('font-size', '18px').css('opacity', 1) }
  if (priceCount >= 7) { $price.css('font-size', '15px').css('opacity', 1) }
  if (priceCount >= 8) { $price.css('font-size', '13px').css('opacity', 1) }
  if (priceCount >= 9) { $price.css('font-size', '11px').css('opacity', 1) }
}



standard.productImageSwitch = function () {
  // if (standard.cache.$body.hasClass('template-product')) {

  //   // Display new photo when thumbnail is clicked.
  //   //$('.product-photo-thumbs span, .product-photo-nav-btns a').on('click touchend', function (evt) {
  //   // $('.product-photo-nav-btns a').on('click touchend', function (evt) {

  //   //   //var product_handle = window.location.href.split('/').pop();
  //   //   //ga('send', 'event', 'pdp_' + product_handle, 'click', 'image_alt', { 'nonInteraction': 1 });
  //   //   //var $el = $(this);


  //   //   // if ($el.hasClass('video')) {
  //   //   //   $('#product-photo-container').addClass('video');
  //   //   //   $('#product-photo-container video source').attr('src', $el.attr('linkUrl'));
  //   //   //   $('#product-photo-container video')[0].load();

  //   //   // }
  //   //   // else {
  //   //   //   $('#product-photo-container').removeClass('video');
  //   //   //   var index = $el.data('index'),
  //   //   //     newImageId = $el.data('image-id'),
  //   //   //     newImageSrc = $el.attr('linkUrl');
  //   //   //   //standard.switchImage(newImageSrc, { id: newImageId }, standard.cache.$productImage[0]);
  //   //   //   //$('#productPhotoImg').data('index', index);
  //   //   // }

  //   // });

  // }
}

// standard.switchImage = function (src, imgObject, el) {
//   // Make sure element is a jquery object
//   var $el = $(el);
//   $el.data('image-id', imgObject.id).attr('src', src);
//   $('#productPhotoImg').attr('data-image-id', imgObject.id)
//   $('#productPhotoImg').attr('data-index', imgObject.index)
// };

standard.relatedProduct = function () {
  if (standard.cache.$body.hasClass('template-product')) {

    if ($('.related-products-list.product-list.row li').length == 3) {
      $('.related-products-list.product-list.row li').each(function () {
        var that = $(this);
        that.addClass('fixWidth');
      });

    }
  }


}

standard.lockScroll = function () {
  $('body').addClass('no-scroll');
  $(window).bind('scroll.lock mousewheel.lock touchmove.lock', function (e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  });
}

standard.unlockScroll = function () {
  $('body').removeClass('no-scroll');
  $(window).unbind('scroll.lock mousewheel.lock touchmove.lock'); // no scroll unbind
}

standard.productImageZoom = function () {
  if (standard.cache.$body.hasClass('template-product')) {
    $('#arrow-container').on('click touchstart', function (evt) {
      if (!evt.target.classList.contains('pdp_image__arrow')) {
        evt.preventDefault();
        standard.lockScroll();
        var product_handle = window.location.href.split('/').pop();
        // ga('send', 'event', 'pdp_' + product_handle, 'click', 'image_zoom', { 'nonInteraction': 1 });
        var $el = $(this);
        var popup = new Popup($('.product-image-zoom.popup'));
        var currentAlt = 1;
        var index = $('#productPhotoImg').attr('data-index');
        $('.product-image-zoom ul li').each((idx, zoomImage) => {
          if ($(zoomImage).find('a').data('image-id') === +$('#productPhotoImg').attr('data-image-id'))
            index = idx + 1
        })
        if (index && parseInt(index, 10) > 0) currentAlt = parseInt(index, 10);
        popup.show({
          top: 0,
          before: function () {
            var $popup = this;
            $popup.find('.js-lazy-load-media').each((idx, image) => {
              !$(image).attr('src') && $(image).attr('src', $(image).data('image-src'))
            })
            var $ul = $popup.find('ul');
            $ul.removeClass('easing');
            var altCount = $ul.find('li').size();
            standard.gotoPhoto($ul, currentAlt);
            $ul.addClass('easing');
            $popup.find('.tip-close a').click(function () {
              popup.hide();
              $('body').css('overflow', 'auto', 'important');
            });
            $popup.find('.zoom-left a').on('click touchstart', function (e) {
              e.preventDefault();
              e.stopPropagation();
              if (currentAlt == 1) {
                currentAlt = altCount;
              } else {
                currentAlt--;
              }
              standard.gotoPhoto($ul, currentAlt);
            });
            $popup.find('.zoom-right a').on('click touchstart', function (e) {
              e.preventDefault();
              e.stopPropagation();
              if (currentAlt >= altCount) {
                currentAlt = 1;
              } else {
                currentAlt++;
              }
              standard.gotoPhoto($ul, currentAlt);
            });
            $('body').on('keyup.popup', function (e) {
              if (e.which === 37) {
                e.preventDefault();
                e.stopPropagation();
                if (currentAlt == 1) {
                  currentAlt = altCount;
                } else {
                  currentAlt--;
                }
                standard.gotoPhoto($ul, currentAlt);
              }
              else if (e.which === 39) {
                e.preventDefault();
                e.stopPropagation();
                if (currentAlt >= altCount) {
                  currentAlt = 1;
                } else {
                  currentAlt++;
                }
                standard.gotoPhoto($ul, currentAlt);
              }
            });
          }
        });
      }
    });
  }
}
standard.gotoPhoto = function ($ul, index) {
  var space = -100 * (index - 1);
  $ul.css({
    "-webkit-transform": "translate3d(" + space + "%, 0px, 0px)",
    "-moz-transform": "translate3d(" + space + "%, 0px, 0px)",
    "-o-transform": "translate3d(" + space + "%, 0px, 0px)",
    "transform": "translate3d(" + space + "%, 0px, 0px)"
  })
}

// standard.popupFaq = function(el) {
//   var $a = $(el);
//   var $li = $a.parent();
//
//   var popup = new Popup($('.faq.popup'));
//
//   popup.show({
//     scroll: true,
//     before: function() {
//       var $popup = this;
//       $popup.find('h5').html($a.find('.title').html());
//       $popup.find('.answer').html($li.find('.answer').html());
//       $popup.find('.tip-close a').click(function() {
//         popup.hide();
//       });
//     }
//   });
// }

standard.expandAnswer = function (el) {
  var $el = $(el);
  var $li = $el.parent();
  $li.find('.answer').toggleClass('active');
}

standard.cartBindings = function (el) {
  var returnCart = $('.return-to-cart');
  var giftMessage = $('.personalized-message');
  var closeCart = $('.close-cart');
  var giftCheck = $('#giftCheck');
  var checkoutValue = $('#checkout-btn');

  giftCheck.change(function () {
    if ($(this).is(":checked")) {
      // giftMessage.addClass('active');
      returnCart.addClass('active');
    }
  }); 
  
  $('body').on('click', '.close-cart', function () {
    giftMessage.removeClass('active');
    returnCart.removeClass('active');
    checkoutValue.val('Checkout');
    standard.closeSidePanel();
    // hj('tagRecording', ['Cart_closed_x_clicked']);
    // ga('send', 'event', 'Cart', 'close with x click', 'Side Panel', { 'nonInteraction': 1 });
  });

  // returnCart.on('click', function() {
  //   giftMessage.removeClass('active');
  //   returnCart.removeClass('active');
  // });
}

standard.returnCart = function (el) {
  var giftMessage = document.querySelector('.personalized-message');

  jQuery.post('/cart/update.js', `attributes[gift-message]=${$(giftMessage).find('textarea').val()}`);
  giftMessage.classList.remove('active');

  if ($(`#giftCheck`).val() === 'Yes') {
    $('.js-edit-message').addClass('active')
  } else  $('.js-edit-message').removeClass('active')


  $(giftMessage).find('textarea').val().length == 0 
  ? $('.js-edit-message').text('Add Gift Message')
  : $('.js-edit-message').text('Edit Gift Message')
}

let saveTimeout;
standard.returnCartPage = function (el) {
  var giftMessage = document.querySelector('.personalized-message-cart');
  if(!$('.gift-message-save-btn').hasClass('disabled')){
    jQuery.post('/cart/update.js', `attributes[gift-message]=${$(giftMessage).find('textarea').val()}`);
    $(el).addClass('disabled').text('Saved')
    saveTimeout = setTimeout(()=>{$(el).text('Save Message').removeClass('disabled')}, 3000)
  }
}

$('#gift-message, #gift-message-cart').on('input', (e)=>{
  $('.gift-message-save-btn').hasClass('disabled') && $('.gift-message-save-btn').removeClass('disabled')
  clearTimeout(saveTimeout)
  $('.gift-message-save-btn').text('Save Message')
})

standard.giftMessageLength = function () {
  let giftMessage = document.querySelector('.personalized-message');
  let textArea = $(giftMessage).find('textarea');
  let maxText = 200;
  let charMessage = $(giftMessage).find('.chars')

  //count characters remaining in text area (max 200)
  textArea.keyup(function() {
    let textLength = textArea.val().length;
    let remainingText = maxText - textLength;
    $('.js-message-num').html(remainingText);

    //change message to red if user hits max chars
    if (remainingText <= 0) {
      charMessage.addClass('red')
    } else {
      charMessage.removeClass('red')
    }
  });
}

standard.bindGiftMessage = function (el) {
  if(el.checked) {
    el.value = 'Yes'
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: {
        attributes: {
          '[gift-wrapped]': 'Yes'
        }
      },

      success: function (data) {
        Cart.prototype.successCLP(data);
      },
      error: function (error) {
        console.error(error)
        Cart.prototype.errorCLP(error);
      }
    }); 
    $('.js-edit-message').addClass('active');
  }
  else {
    el.value = 'No'
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: {
        updates: { 33288723890275: 0 },
        attributes: {
          '[gift-wrapped]': 'No',
          '[gift-wrapped-paid]': 'No'
        }
      },

      success: function (data) {
        Cart.prototype.successCLP(data);
      },
      error: function (error) {
        console.error(error)
        Cart.prototype.errorCLP(error);
      }
    }); 
    $('.js-edit-message').removeClass('active')
  }
}

standard.bindGiftMessageCartPage = function (el) {
  var giftMessage = document.querySelector('.personalized-message-cart');
  var checkoutValue = $('#checkout-btn-cart');
  if ($(el).is(":checked")) {
    giftMessage.classList.add('active');
    el.value = 'Yes'
    jQuery.post('/cart/update.js', `attributes[gift-wrapped]=Yes`);
    $('.gift-message-container-cart').addClass('expanded')
  }
  else {
    giftMessage.classList.remove('active');
    el.value = 'No'
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: {
        updates: { 33288723890275: 0 },
        attributes: {
          '[gift-wrapped]': 'No',
          '[gift-wrapped-paid]': 'No'
        }
      },

      success: function (data) {
        Cart.prototype.successCLP(data);
        window.location.reload()
      },
      error: function (error) {
        console.error(error)
        Cart.prototype.errorCLP(error);
      }
    });
    $('.gift-message-container-cart').removeClass('expanded')
  }
}

let removeGiftWrap = function() {
  let giftWrapCheck = $("#giftWrapCheck")[0]
  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    type: 'post',
    data: {
      updates: { 33288723890275: 0 },
      attributes: {
        '[gift-wrapped-paid]': 'No'
      }
    },

    success: function (data) {
      Cart.prototype.successCLP(data);
      if (window.location.href.indexOf("cart") > -1) {
        window.location.reload()
      }
    },
    error: function (error) {
      console.error(error)
      Cart.prototype.errorCLP(error);
    }
  }); 
  giftWrapCheck.unchecked;
  giftWrapCheck.value = 'no';
}

standard.bindGiftWrap = function (el) {
  if(el.checked) {
    el.value = 'Yes'

    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: { 
        updates: { 33288723890275: 1 },
        attributes: {
          '[gift-wrapped]': 'Yes',
          '[gift-wrapped-paid]': 'Yes'
        }
      },

      success: function (data) {
        Cart.prototype.successCLP(data);
        data && $('#cart-toggle').addClass('fill')
        if (window.location.href.indexOf("cart") > -1) {
          window.location.reload()
        }
      },
      error: function (error) {
        console.error(error)
        Cart.prototype.errorCLP(error);
      }
    });
  } else {
    el.value = 'No';
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: {
        updates: { 33288723890275: 0 },
        attributes: {
          '[gift-wrapped-paid]': 'No'
        }
      },

      success: function (data) {
        Cart.prototype.successCLP(data);
        if (window.location.href.indexOf("cart") > -1) {
          window.location.reload()
        }
      },
      error: function (error) {
        console.error(error)
        Cart.prototype.errorCLP(error);
      }
    }); 
  }
}

standard.placeholderFix = function () {
  if (document.createElement('input').placeholder == undefined) {
    standard.cache.$html.addClass('no-placeholder');

    standard.cache.$placeholders.each(function () {
      var $el = $(this);
      if ($el.val() === '') {
        var hint = $el.attr('placeholder');
        $el.val(hint).addClass('hint');
      }
    });

    standard.cache.$placeholders.focus(function () {
      var $el = $(this);
      if ($el.val() === $el.attr('placeholder')) {
        $el.val('').removeClass('hint');
      }
    }).blur(function () {
      var $el = $(this);
      if ($el.val() === '') {
        $el.val($el.attr('placeholder')).addClass('hint');
      }
    });
  }
}

standard.formValidation = function () {
  $('input.error, textarea.error').focus(function () {
    $(this).removeClass('error');
  });


  $('form :submit').click(function () {
    var $el = $(this);
    $el.parents('form').find('input.hint, textarea.hint').each(function () {
      $el.val('').removeClass('hint');
    });
    return true;
  });
}

standard.saveCartOnClose = function () {
  if (standard.cache.$body.hasClass('template-cart')) {
    $(window).unload(function () {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: $('form[action="/cart"]').serialize(),
        dataType: 'json',
        async: false
      };
      $.ajax(params);
    });
  }
}




standard.productDetailsAndCarePopup = function (bundlePopup) {
  if (bundlePopup) {
    if (bundlePopup === 'whats-included') {
      $('.product-details-and-care.popup').find('#materials-and-care').css('display', 'none')
      $('.product-details-and-care.popup').find('#whats-included').css('display', 'flex')
    }
    else {
      $('.product-details-and-care.popup').find('#materials-and-care').css('display', 'flex')
      $('.product-details-and-care.popup').find('#whats-included').css('display', 'none')
    }
  }

  var popup = new Popup($('.product-details-and-care.popup'));

  popup.show({
    scroll: true,
    before: function () {
      $('body').css('overflow', 'hidden');
      var product_handle = window.location.href.split('/').pop();
      // hj('tagRecording', ['lightbox_pdp']);
      // ga('send', 'event', 'pdp_' + product_handle, 'click', 'pdp_lightbox', { 'nonInteraction': 1 });
      var $popup = this;

      $popup.find('.tip-close a').click(function () {
        popup.hide();
        $('body').css('overflow', 'auto', 'important');
      });

    },
    after: function () {
      setTimeout(() => {
        $('body').on('click', function (e) {
          e.stopImmediatePropagation()
          if (!$(e.target).closest('.product-details-and-care.popup:not(.template)').length) {
            popup.hide();
            $('body').css('overflow', 'auto', 'important');
          }
        });
      }, 10)
    }
  });
}

standard.sizeGuidePopup = function (bundlePopup) {
  if (bundlePopup) {
    $('.size-guide.popup').find('.size-guide.popup').css('display', 'flex')
    $('.size-guide.popup').find('#materials-and-care').css('display', 'none')
    $('.size-guide.popup').find('#whats-included').css('display', 'none')
  }

  var popup = new Popup($('.size-guide.popup'));

  popup.show({
    scroll: true,
    before: function () {
      // $('body').css('overflow', 'hidden')
      // var product_handle = window.location.href.split('/').pop();
      // var $popup = this;

      // $popup.find('.tip-close a').click(function () {
      //   popup.hide();
      //   $('body').css({ 'overflow': 'auto !important' })
      // });

      // $popup.find('.size-guide_category_header_item').click((event) => {
      //   let $event = event
      //   let closest = $event.target.closest('.size-guide_category_header_item')
      //   let cat = closest.classList[1].split('_').pop()
      //   closest.parentElement.classList += " active"

      //   // Set all other category headers to inactive by removing 'active' class
      //   let allHeaders = document.querySelectorAll('.size-guide_category_header_item')
      //   allHeaders.forEach(function (el) {
      //     if (el.classList[1].split('_').pop() != cat) {
      //       el.parentElement.classList.remove("active")
      //     }
      //   })

      //   // Set all other category tables to inactive by removing 'active' class
      //   let allTables = document.querySelectorAll('.size-guide_table')
      //   allTables.forEach(function (el) {
      //     if (el.classList[1].split('_').pop() === cat) {
      //       el.classList += " active"
      //     } else {
      //       el.classList.remove("active")
      //     }
      //   })
      // })
    },
    after: function () {



      // setTimeout(() => {
      //   $('body').on('click touch', function (e) {
      //     e.stopImmediatePropagation()
      //     if (!$(e.target).closest('.size-guide.popup:not(.template)').length) {
      //       popup.hide();
      //       $('body').css('overflow', 'auto', 'important');
      //     }
      //   });
      // }, 10)


      // let sizeGuide = $('.size-guide.clone-popup')
      // let categoryRow = document.querySelector('.size-guide.clone-popup .js-category-row')
      // let categoryRowSlider;
      // const leftControl = $(sizeGuide).find('.js-sizeguide-left')
      // const rightControl = $(sizeGuide).find('.js-sizeguide-right')

      // let setFlkty = () => {
      //   /*if (window.matchMedia("(max-width: 768px)").matches) {
      //     categoryRowSlider = new Flickity(categoryRow, {
      //       wrapAround: true,
      //       cellAlign: 'center',
      //       contain: true,
      //       imagesLoaded: true,
      //       percentPosition: false,
      //       groupCells: 1,
      //       draggable: true,
      //       prevNextButtons: false,
      //       pageDots: false
      //     })
      //     setTimeout(() => {
      //       $(categoryRowSlider.element).find('.flickity-viewport').css({ 'min-height': '64px', width: '80%' })
      //       $(categoryRowSlider.element).find('.flickity-slider').addClass('f aic jcb').css('min-height: 64px')
      //       categoryRowSlider.resize()
      //     }, 1500)

      //     $(leftControl).click(() => {
      //       let $currentTable = $('.size-guide.clone-popup .size-guide_table.active')
      //       let $prevTable = $currentTable.index() <= 3
      //         ? $('.size-guide.clone-popup').find('.size-guide_table').eq(4).addClass('active')
      //         : $currentTable.prev()
      //       $currentTable.removeClass('active')
      //       $('.size-guide.clone-popup .size-guide_category_row .category-header').removeClass('active')
      //       $prevTable.addClass('active')
      //       categoryRowSlider.previous()
      //       $('.size-guide.clone-popup .size-guide_category_row .category-header').eq(categoryRowSlider.selectedIndex).addClass('active')

      //     })
      //     $(rightControl).click(() => {
      //       let $currentTable = $('.size-guide.clone-popup .size-guide_table.active')
      //       let $nextTable = $currentTable.index() >= 7
      //         ? $('.size-guide.clone-popup').find('.size-guide_table').eq(0).addClass('active')
      //         : $currentTable.next()
      //       $currentTable.removeClass('active')
      //       $('.size-guide.clone-popup .size-guide_category_row .category-header').removeClass('active')
      //       $nextTable.addClass('active')
      //       categoryRowSlider.next()
      //       $('.size-guide.clone-popup .size-guide_category_row .category-header').eq(categoryRowSlider.selectedIndex).addClass('active')
      //     })
      //   }
      //   else if (categoryRowSlider) categoryRowSlider.destroy() */
      // }
      // //setFlkty()
      // //$(window).on('resize', () => setFlkty())
    }
  });
}

// Initialize JS on docready
$(standard.init);

var Popup = function ($template) {
  var self = this;
  this.showing = false;
  this.$template = $template;
  //this.$background = $("<div class='popup-background'></div>")
  // this.$background.click(function (e) {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   self.hide();
  //   $('body').css('overflow', 'auto');
  // });
  // $('body').append(this.$background);
}

Popup.prototype.show = function (options) {
  if (this.showing) {
    return false;
  }
  this.options = options || {};
  var self = this;
  this.$popup = this.$template.clone();
  this.$popup.addClass('clone-popup').removeClass('template hidden')

  this.$popup.find('a.close').click(function (e) {
    self.hide();
    e.preventDefault();
    e.stopPropagation();
    return false;
  });

  // Escape closes the popup
  $('body').bind('keyup.popup', function (e) {
    if (e.which === 27) {
      e.preventDefault();
      e.stopPropagation();
      self.hide();
      $('body').css('overflow', 'auto');
    }
  });

  // No scroll mobile
  if (!this.options.scroll) {
    $('body').bind('touchmove.popup', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
    standard.lockScroll();
  }

  if (this.options.before) {
    this.options.before.apply(this.$popup, [])
  }

  $('body').addClass('popup');
  $('body').append(this.$popup);
  // if (options.top != null) {
  //   this.$popup.css('top', options.top);
  // } else {
  //   this.$popup.css('top', $(window).scrollTop() + (options.offset || 50));
  // }
  this.$popup.fadeIn(300);
  //this.$background.css({ 'opacity': '0.8' });
  //this.$background.fadeIn(300);
  this.showing = true;
  if (this.options.after) {
    this.options.after.apply(this.$popup, [])
  }
}

Popup.prototype.hide = function () {
  if (!this.showing) return false;
  var self = this;
  //this.$background.fadeOut(300);
  this.$popup.fadeOut(300, function () {
    self.$popup.remove();
    self.showing = false;
  });

  standard.unlockScroll();
  $('body').removeClass('popup');
  $('body').unbind('touchmove.popup'); // no scroll mobile unbind
  $('body').unbind('keyup.popup'); // escape unbind
  $('body').attr('onclick', '').unbind('click')

  if (this.options.hide) {
    this.options.hide.apply(this.$popup, [])
  }

}
